import React,{useEffect,useState}from'react';

const BACKEND_URL=process.env.REACT_APP_BACKEND_URL;
const qrCache=new Map();
const MAX_CACHE=80;

function rememberQr(key,url){
 if(qrCache.has(key))return qrCache.get(key);
 qrCache.set(key,url);
 if(qrCache.size>MAX_CACHE){
  const first=qrCache.keys().next().value;
  const old=qrCache.get(first);
  qrCache.delete(first);
  try{URL.revokeObjectURL(old)}catch{}
 }
 return url;
}

export default function QrCodeBlock({value,className='',style={}}){
 const[src,setSrc]=useState('');
 useEffect(()=>{
  let active=true;
  const key=String(value||'').trim();
  if(!key){setSrc('');return()=>{active=false}}
  const cached=qrCache.get(key);
  if(cached){setSrc(cached);return()=>{active=false}}
  setSrc('');
  fetch(`${BACKEND_URL}/api/lots/render-qr`,{
   method:'POST',
   headers:{'Content-Type':'application/json'},
   credentials:'include',
   body:JSON.stringify({qr_code:key}),
  })
   .then(r=>{if(!r.ok)throw new Error('QR non disponibile');return r.blob()})
   .then(blob=>{
    if(!active)return;
    const url=rememberQr(key,URL.createObjectURL(blob));
    setSrc(url);
   })
   .catch(()=>{if(active)setSrc('')});
  return()=>{active=false};
 },[value]);
 if(!src)return <div className={className} style={{background:'#fff',...style}}/>;
 return <img src={src} alt="QR lotto" className={className} style={{display:'block',objectFit:'contain',background:'#fff',...style}}/>;
}
